export const BORDER = '1px solid rgba(255,255,255,0.06)'
export const RADIUS = 6
export const VW_BLUE = '#001E50'

export function formatChf(v) {
  const n = Number(v)
  if (!Number.isFinite(n)) return '—'
  return `${Math.round(n).toLocaleString('fr-CH')} CHF`
}

export function formatPct(v, signed = true) {
  const n = Number(v)
  if (!Number.isFinite(n)) return '—'
  const s = n.toLocaleString('fr-CH', { maximumFractionDigits: 1, minimumFractionDigits: 0 })
  if (!signed) return `${s} %`
  return `${n > 0 ? '+' : ''}${s} %`
}

export function TrendArrow({ pct }) {
  const n = Number(pct)
  if (!Number.isFinite(n) || Math.abs(n) < 1) return <span style={{ color: 'var(--muted)' }}>→ {formatPct(0)}</span>
  if (n > 0) return <span style={{ color: '#86efac' }}>↗ {formatPct(n)}</span>
  return <span style={{ color: '#fca5a5' }}>↘ {formatPct(n)}</span>
}

export const sectionStyle = {
  marginBottom: 40,
  paddingBottom: 32,
  borderBottom: BORDER,
}

export const sectionTitleStyle = {
  fontSize: 11,
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  color: 'var(--text-tertiary)',
  marginBottom: 20,
  fontWeight: 500,
}

export const cardStyle = {
  background: 'rgba(255,255,255,0.02)',
  border: BORDER,
  borderRadius: RADIUS,
  padding: '20px 24px',
}

export const kpiValueStyle = {
  fontSize: 28,
  fontWeight: 300,
  color: '#fff',
  lineHeight: 1.1,
  marginTop: 8,
}

export const kpiLabelStyle = {
  fontSize: 11,
  color: 'var(--text-tertiary)',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
}
